import React, { Component } from 'react';
import _ from 'lodash';
import { Grid } from 'react-bootstrap';
import Footer from '../../components/Recruiter/Footer/Footer';
import PrivacyPolicy from '../../components/ContentPages/PrivacyPolicy';
import TermsAndConditions from '../../components/ContentPages/TermsAndConditions';
import SecurityPolicy from '../../components/ContentPages/SecurityPolicy';
import './SimpleLayout.css';
import Header from '../../components/Common/Header/Header';
import Account from '../../components/Authentication/Account';
import CandidateInterviewScheduleOverview from '../../container/CandidateInterviewScheduleOverview/CandidateInterviewScheduleOverview';

import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';
import CandidateInterviewInvite from '../../container/Candidate/CandidateInterviewInvite/CandidateInterviewInvite';

/**
* @desc Layout for privacy policy, user terms and conditions and security policy
* @version 
* @author Praveen George 
*/
class SimpleLayout extends Component {
  render() {
    return (
      <div className="root simpleLayout">
        <div className="app-container simpleLayout">
          <Header isSimpleLayout={true} />
          <div className="app-body">
            <Grid>
              <Switch>
                <PropsRoute exact path="/content-pages/PrivacyPolicy" component={PrivacyPolicy} />
                <PropsRoute exact path="/content-pages/TermsAndConditions" component={TermsAndConditions} />
                <PropsRoute exact path="/content-pages/SecurityPolicy" component={SecurityPolicy} />
                {/* <PropsRoute exact path="/candidateInterview/CandidateInterviewScheduleOverview" component={CandidateInterviewScheduleOverview} /> */}
                <PropsRoute exact path="/candidateInterview/interview" component={CandidateInterviewInvite} />
                <PropsRoute exact path="/account" component={Account}/>
                </Switch>
              </Grid>
          </div>
          <div className="simpleLayoutFooter">
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}
/**
* @desc merging props
* @param component ,rest
* @return component,finalprops
*/
const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return (
    React.createElement(component, finalProps)
  );
}
/**
* @desc adding props to router
* @param component ,rest
* @return merged props,component
*/
const PropsRoute = ({ component, ...rest }) => {
  return (
    <Route {...rest} render={routeProps => {
      return renderMergedProps(component, routeProps, rest);
    }} />
  );
}

export default SimpleLayout;



// WEBPACK FOOTER //
// ./src/hoc/layout/SimpleLayout.js